// extracted by mini-css-extract-plugin
export var externalLink = "_ck-0";
export var internalLinkLabel = "_ck-1";